"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SvgIcon_1 = __importDefault(require("./SvgIcon"));
const ArrowRight = (_a) => {
    var rest = __rest(_a, []);
    return (react_1.default.createElement(SvgIcon_1.default, Object.assign({ "data-icon": "arrow", viewBox: "0 0 7 11", fill: "none" }, rest),
        react_1.default.createElement("path", { d: "M1.08333 9.75002L5.25 5.58335L1.08333 1.41669", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
exports.default = ArrowRight;
//# sourceMappingURL=ChevronRight.js.map